import { FC, Fragment, useState, useEffect } from "react";
import { AlertActionType, useAlertContext } from "./AlertContext";
import { Alert, AlertGroup } from "@patternfly/react-core";
import "./AlertComponent.scss";
import { isEmpty } from 'lodash';

const AlertComponent: FC = () => {
  const {state, setAlertState} = useAlertContext();
  const [localState, setLocalState] = useState([]);
  const ALERT_TIMEOUT = (1000) * 5; // 5 seconds
  useEffect(()=>{
    if (state.alertState.length > localState.length) {
      setTimeout(()=> {
        setAlertState({
          type: AlertActionType.HIDE,
          payload: state.alertState[localState.length]
        });
      }, ALERT_TIMEOUT);
    }
    setLocalState(state.alertState);
    // eslint-disable-next-line
  }, [state.alertState]);
  return (
    <Fragment>
      <AlertGroup className="alert-group" isToast  isLiveRegion>
        {
          localState.map(({title, variant, description, id, actionLinks})=> (
            <Alert
              title={title}
              data-testid={title}
              variant={variant}
              {...(actionLinks.length > 0 &&
                {actionLinks: (<Fragment>
                    {actionLinks.map((actionLink)=> (actionLink))}
                </Fragment>)})}
              key={"alert-"+ id}>
            {!isEmpty(description) ? <p>{description}</p> : null}
            </Alert>
          ))
        }
      </AlertGroup>
    </Fragment>
  )
};

export default AlertComponent;
